import { DefaultLanguage } from '../i18n/config';

export interface FormatNumberOptions extends Intl.NumberFormatOptions {
  /**
   * Locale (`en-US`, `es-MX`, `fr-CA`). When omitted, falls back to the
   * configured default.
   */
  locale?: string;
}

/**
 * Formats a numeric value per the active locale - thousands separator, decimal
 * separator, and (when requested) precision all follow the locale's rules.
 *
 * Wraps `Intl.NumberFormat` directly so the full options surface
 * (`minimumFractionDigits`, `notation: 'compact'`, etc.) flows through.
 */
export function formatNumber(value: number, opts: FormatNumberOptions = {}): string {
  const { locale, ...intlOpts } = opts;
  return new Intl.NumberFormat(locale ?? DefaultLanguage, intlOpts).format(value);
}
